import { Truck, FileText, ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SITE } from "@/lib/siteData";

export default function PromoBanner() {
  const scrollToAppointment = () => {
    const el = document.querySelector("#appointment");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="py-16 lg:py-24 bg-slate-50" data-testid="promo-banner-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {/* Dépannage 24/7 */}
          <div className="group relative overflow-hidden rounded-3xl bg-slate-900 text-white shadow-xl" data-testid="promo-depanneuse-card">
            <div className="absolute inset-0">
              <img
                src="/promo-depanneuse.jpg"
                alt="Dépanneuse Sphère Auto"
                className="w-full h-full object-cover opacity-50 group-hover:opacity-60 group-hover:scale-105 transition-all duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/70 to-slate-950/20" />
            </div>

            <div className="relative p-8 lg:p-10 min-h-[420px] flex flex-col justify-between">
              <div className="flex items-center gap-3">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-red-600 rounded-full">
                  <span className="w-1.5 h-1.5 bg-white rounded-full animate-pulse" />
                  <span className="text-[10px] font-bold tracking-widest uppercase">24/24h • 7/7j</span>
                </div>
                <Truck className="w-6 h-6 text-blue-300" />
              </div>

              <div>
                <h3 className="font-heading font-extrabold text-3xl lg:text-4xl tracking-tight uppercase">
                  Dépannage<br />
                  <span className="text-blue-400">d&apos;urgence</span>
                </h3>
                <p className="mt-4 text-slate-300 text-base lg:text-lg leading-relaxed">
                  Panne ? Accident ? On vient vous chercher. Intervention rapide sur Loos-en-Gohelle et alentours, jour et nuit.
                </p>
                <a
                  href={SITE.phoneTel}
                  className="mt-6 inline-flex items-center gap-3 bg-red-600 hover:bg-red-700 text-white font-bold px-6 py-4 rounded-xl transition-all hover:scale-105"
                  data-testid="promo-depanneuse-cta"
                >
                  <Phone className="w-5 h-5" />
                  <span className="text-base">Appeler {SITE.phoneDisplay}</span>
                </a>
              </div>
            </div>
          </div>

          {/* Carte Grise */}
          <div className="group relative overflow-hidden rounded-3xl bg-blue-600 text-white shadow-xl" data-testid="promo-carte-grise-card">
            <div className="absolute inset-0">
              <img
                src="/promo-carte-grise.jpg"
                alt="Service Carte Grise Sphère Auto"
                className="w-full h-full object-cover opacity-30 group-hover:opacity-40 group-hover:scale-105 transition-all duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-blue-900 via-blue-800/70 to-blue-700/20" />
            </div>

            <div className="relative p-8 lg:p-10 min-h-[420px] flex flex-col justify-between">
              <div className="flex items-center gap-3">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-white/15 backdrop-blur border border-white/30 rounded-full">
                  <span className="text-[10px] font-bold tracking-widest uppercase text-white">Service Habilité</span>
                </div>
                <FileText className="w-6 h-6 text-blue-200" />
              </div>

              <div>
                <h3 className="font-heading font-extrabold text-3xl lg:text-4xl tracking-tight uppercase">
                  Carte Grise<br />
                  <span className="text-blue-200">en direct</span>
                </h3>
                <p className="mt-4 text-blue-50 text-base lg:text-lg leading-relaxed">
                  Plus de file d&apos;attente en préfecture. Duplicata, changement de propriétaire, cession : on s&apos;occupe de tout, rapidement.
                </p>
                <Button
                  onClick={scrollToAppointment}
                  size="lg"
                  className="mt-6 bg-white text-blue-700 hover:bg-blue-50 font-bold px-6 py-6 rounded-xl group/btn transition-all hover:scale-105"
                  data-testid="promo-carte-grise-cta"
                >
                  Démarrer ma démarche
                  <ArrowRight className="ml-2 w-5 h-5 group-hover/btn:translate-x-1 transition-transform" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
